<template>
  <div class="xscontainer jsjiesh">
    <div class="shang">
      <div class="left">
        <div class="tabcss">
          <p class="linkcs111">数据质量(含主数据)课程介绍</p>
        </div>
        <div class="contentcss">
          <p class="btcss1">课程简介</p>
          <p class="cot">记者从广州市公安局天河区分局了解到，攻击者利用技术手段绕过该公司的网络防护装置，非法进入自助设备的后台系统，通过横向移动渗透控制多台网络设备，向这些设备中的后台系统非法上传多份攻击程序，使其官方网站和部分业务系统受到影响，导致网络服务中断数小时，给公司造成了重大损失，部分用户隐私信息疑遭泄露。事件发生后，该公司立即启动应急预案，第一时间尝试恢复系统，并向当地公安机关报案。公安机关高度重视，提取相关攻击程序样本，全面固定相关涉案证据，并组织专业技术团队开展技术溯源。

            据警方透露，此次网络攻击是境外黑客组织的一次有组织、有预谋的大规模网络攻击行动，带有明显的网络战痕迹，并非普通个人黑客所能完成。初步追踪溯源发现，该黑客组织长期使用开源工具对我重要部门、敏感行业和科技公司开展网络资产扫描探测，广泛搜寻攻击目标，通过技术手段挖掘目标单位网络防护薄弱环节和攻击点位，伺机入侵控制目标系统，窃取、破坏重要数据，干扰相关机构正常运营。技术团队分析认为，攻击者的作案手法及相关技术水平较低，攻击过程中暴露出大量网络线索，公安机关正在对相关线索开展技术分析和侦查调查。
            警方表示，该网络攻击事件不仅侵犯了企业的合法权益，也严重威胁到我国网络空间秩序和公众利益，公安机关将依法严厉打击此类违法犯罪活动</p>
        </div>
        <div class="contentcss">
          <p class="btcss1">课程纲要</p>
          <div class="coldiv">
            <el-table :data="tableData" cell-style="height:5rem" >
              <el-table-column
                  prop="name"
                  width="280">
              </el-table-column>
              <el-table-column
                  prop="address">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="right324">
        <div class="upcs45">
          <div class="upin13212">
            <img class="kkdfls" src="@/assets/xxkc/xjt.png">
            <div style="color: #ffffff">请选择讲师</div>
          </div>
          <div class="kkllwerr">
            <img class="kkdsfdf" src="@/assets/xxkc/22_1@4x.png">
            <div class="jjdfdfdsf">
              <p style="color: #f1f0f0;letter-spacing: 1px;font-size: 10px;">课程讲师</p>
              <p style="color: #ffffff;font-size: 18px;font-weight: bold;letter-spacing: 2px">杜绍森</p>
            </div>
          </div>
        </div>
        <div class="dowcs565">
          <div class="mitm1">全面认识数据要素</div>
          <div class="mitm">全面认识数据要素</div>
          <div class="mitm">全面认识数据要素</div>
          <div class="mitm">全面认识数据要素</div>
          <div class="mitm">全面认识数据要素</div>
          <div class="mitm">全面认识数据要素</div>
        </div>
        <div class="xia234">
          <div class="llwerewr">我要学习</div>
          <div class="ksdfvdf">
            <div class="nnsdfsh">直播</div>
            <div class="nnsdfsh">课程</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [{
        name: 'DCMM的认知',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        name: '数字化转型的深层认识',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        name: '数字化转型的深层认识',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        name: '数字化转型的深层认识',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        name: '数字化转型的深层认识',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        name: '数字化转型的深层认识',
        address: '上海市普陀区金沙江路 1517 弄'
      },],
    };
  },
};
</script>

<style scoped>
.jsjiesh{
  width: 60%;
  display: flex;
  gap: 1rem;
  align-items: start;
  flex-direction: column;
}
.kkdsfdf{
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  border:2px solid #ffffff;
}
.jjdfdfdsf{
  display: flex;
  flex-direction: column;
  gap: 0.5px;
}
.kkllwerr{
  width: 100%;
  height: 80%;

  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
.shang{
  width: 100%;
  display: flex;
  gap: 2rem;
}
.left{
  width:80%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.right324{
  width:20%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.tabcss{
  width: 70%;
  display: flex;
  justify-content: start;
}
.linkcs111{
  font-weight: bold;
  font-size: 1rem;

}
.kkdfls{
  width: 1.2rem;
  height: 1.2rem;
}
.btcss1{
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
  color: #46abf5;
}
.contentcss{
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.cot{
  letter-spacing: 1.5px;
  line-height: 32px;
}
.upcs45{
  min-width: 100%;
  height: 8rem;
  background-color: #347de6;
  display: flex;
  flex-direction: column;
  align-items: start;
}
.xia234{
  margin-top: 2rem;
  width: 100%;
  height: 7.4rem;
  background-color: #edf7ff;
  border:1px solid #cee4f5;
  background-image: url('../../assets/xxkc/10.png');
  background-position: 90%;  /* 分别设置位置 */
  background-repeat: no-repeat, no-repeat;   /* 分别设置重复方式 */
  background-size: 25%;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  padding-left: 2rem;
  letter-spacing: 1px;
}
.llwerewr{
  font-weight: bold;
  font-size: 16px;
  color: #46abf5;
}
.ksdfvdf{
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
}
.nnsdfsh{
  color: #ffffff;
  background-color: #46abf5;
  height: 1.3rem;
  width: 2.5rem;
  border-radius: 3px;
  display: flex;
  justify-content: center;
}
.upin13212{
  width: 100%;
  height: 2rem;
  background-color: #0e65e3;
  opacity: 0.5;
  color: #ffffff;
  display: flex;
  justify-content: start;
  align-items: center;
  padding-left: 1rem;
}

.dowcs565{
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
}
.mitm{
  height: 3rem;
  line-height: 3rem;
  text-align: left;
  padding-left: 20px;
  width: 100%;
  border:1px solid #a4a2a2;
}
.mitm1{
  height: 3rem;
  line-height: 3rem;
  text-align: left;
  padding-left: 20px;
  width: 100%;
  border:1px solid #46abf5;
  color: #46abf5;
}
</style>
